export class MaxLengthValidationRule {
    // #region Vars
    name = 'maxlen';
    // #endregion
    // #region Core
    validate(validation, rule, value, object) {
        //Message
        let tMax = rule.props?.maxlen ?? rule.props;
        let tMessage = host.localizer?.tc('system.Validation.StringLengthMax', [validation.displayName, tMax, '']);
        //Data
        if (value === undefined || value === null) {
            return {
                isValid: true
            };
        }
        if (/(string|array)/.test(typeof value) === false) {
            return {
                isValid: false,
                message: tMessage
            };
        }
        if (value.length > 0 && value.length > tMax) {
            return {
                isValid: false,
                message: tMessage
            };
        }
        return { isValid: true };
    }
}
